import React from "react";
import "./WeekSelector.css";
import { useSiteContext } from "../SiteContext";
import { usePayPeriods, getPayPeriodDate } from "../hooks/usePayPeriods";

const WeekSelector: React.FC = () => {
  const {
    payPeriods,
    setWeek,
    setYear,
    week,
    year,
    startDate,
    endDate,
    translator,
  } = useSiteContext();

  // Fetch pay periods + current-week auto-pick + startDate/endDate sync (shared hook)
  const { error } = usePayPeriods();

  // Filter pay periods based on selected year
  const filteredPayPeriods = payPeriods
    .filter((period) => {
      if (!period || !period.AccountingYear) return false;
      return period.AccountingYear.toLocaleString() === year && period.WeekNumber > 0;
    });

  // Get available years from pay periods
  const availableYears = Array.from(new Set(payPeriods.map((period) => period.AccountingYear)));

  return (
    <div className="weekSelector-bar">
      <div className="date-range">
        <span>
          {translator.translate("StartDate")} {payPeriods.length > 0 ? startDate : "N/A"}
        </span>
        <span>
          {translator.translate("EndDate")} {payPeriods.length > 0 ? endDate : "N/A"}
        </span>
      </div>

      <div className="dropdowns">
        <div className="dropdown-item">
          <label>{translator.translate("Week")}</label>
          <select value={week} onChange={(e) => setWeek(parseInt(e.target.value, 10))}>
            {filteredPayPeriods.map((payPeriod) => (
              <option key={payPeriod.WeekNumber} value={payPeriod.WeekNumber}>
                {payPeriod.WeekNumber} ({getPayPeriodDate(new Date(payPeriod.StartDate))} - {getPayPeriodDate(new Date(payPeriod.EndDate))})
              </option>
            ))}
          </select>
        </div>

        <div className="dropdown-item">
          <label>{translator.translate("Year")}</label>
          <select value={year} onChange={(e) => setYear(e.target.value)}>
            {availableYears.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
      </div>
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default WeekSelector;
